import React from 'react';
import svlogo from '../assets/sv_logo.png';

const Header = () => (
  <div className="title-logo-row">
    <img src={svlogo} alt="" className="title-logo" aria-hidden="true" />
    <h1>Biertracker</h1>
    <img src={svlogo} alt="" className="title-logo" aria-hidden="true" />
  </div>
);

export default Header;
